import React, { useEffect, useRef, useState } from 'react';
import Navigation from "../Navigation/Navigation";
import Footer from '../Footer/Footer';
import slider1 from '../../asset/img/slider1.jpg'
import slider2 from '../../asset/img/slider2.jpg'
import slider3 from '../../asset/img/slider3.jpg'
import slider4 from '../../asset/img/slider4.jpg'
import home1 from '../../asset/img/home1.jpg'
import home2 from '../../asset/img/home2.jpg'
import home3 from '../../asset/img/home3.jpg'
import home4 from '../../asset/img/home4.jpg'
import cortage from '../../asset/img/cortage.jpg'
import mezzanine from '../../asset/img/mezzanine.jpg'
import gallery1 from '../../asset/img/gallery1.jpg'
import gallery2 from '../../asset/img/gallery2.jpg'
import gallery3 from '../../asset/img/gallery3.jpg'
import gallery4 from '../../asset/img/gallery4.jpg'
import gallery5 from '../../asset/img/gallery5.jpg'
import gallery6 from '../../asset/img/gallery6.jpg'
import gallery7 from '../../asset/img/gallery7.jpg'
import gallery8 from '../../asset/img/gallery8.jpg'
import gallery9 from '../../asset/img/gallery9.jpg'
import gallery10 from '../../asset/img/gallery10.jpg'
import gallery11 from '../../asset/img/gallery11.jpg'
import gallery12 from '../../asset/img/gallery12.jpg'
import gallery13 from '../../asset/img/gallery13.jpg'
import gallery14 from '../../asset/img/gallery14.jpg'
import gallery15 from '../../asset/img/gallery15.jpg'
import facilities1 from '../../asset/img/facilities1.jpg'
import facilities2 from '../../asset/img/facilities2.jpg'
import facilities3 from '../../asset/img/facilities3.jpg'
import facilities4 from '../../asset/img/facilities4.jpg'
import facilities5 from '../../asset/img/facilities5.jpg'
import room from '../../asset/img/room.jpg'
import AOS from 'aos';
import "./Home.css";
import { Element } from 'react-scroll';
import { Link } from 'react-scroll';
import { Link as LinkRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
const Home = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,  // Duration of the animation
            easing: 'ease-in-out',  // Easing function for the animation
            once: true,  // Animation should only run once
        });
    }, []);
    const images = [
        gallery1,
        gallery2,
        gallery3,
        gallery4,
        gallery5,
        gallery6,
        gallery7,
        gallery8,
        gallery9,
        gallery10,
        gallery11,
        gallery12,
        gallery13,
        gallery14,
        gallery15,
    ];
    const stayGridRef = useRef(null);
    const [isSliderActive, setIsSliderActive] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined') return undefined;
        const updateSliderState = () => {
            setIsSliderActive(window.innerWidth < 992);
        };
        updateSliderState();
        window.addEventListener('resize', updateSliderState);
        return () => {
            window.removeEventListener('resize', updateSliderState);
        };
    }, []);

    useEffect(() => {
        if (!isSliderActive) return undefined;
        const slider = stayGridRef.current;
        if (!slider) return undefined;
        const step = slider.clientWidth;
        const intervalId = setInterval(() => {
            if (slider.scrollWidth - slider.scrollLeft <= slider.clientWidth + 8) {
                slider.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
                slider.scrollBy({ left: step, behavior: 'smooth' });
            }
        }, 4000);
        return () => clearInterval(intervalId);
    }, [isSliderActive]);

    return (
        <div className="home-page">
            {/* <div className="header-fixed"> */}
            <Navigation />
            {/* </div> */}
            <div>
                <Element name="home">
                    {/*slider  */}
                    <div data-aos="fade-up">
                        {/* <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel" className='sliderMainDiv'> */}
                        <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
                            <ol class="carousel-indicators">
                                <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                                <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                                <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                                <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
                            </ol>
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <img class="d-block w-100" src={slider1} alt="First slide" className='headerSlider' />
                                </div>
                                <div class="carousel-item">
                                    <img class="d-block w-100" src={slider2} alt="Second slide" className='headerSlider' />
                                </div>
                                <div class="carousel-item">
                                    <img class="d-block w-100" src={slider3} alt="Third slide" className='headerSlider' />
                                </div>
                                <div class="carousel-item">
                                    <img class="d-block w-100" src={slider4} alt="Third slide" className='headerSlider' />
                                </div>
                            </div>
                            <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="sr-only">Next</span>
                            </a>
                        </div>
                    </div>

                    {/* content */}
                    <div style={{ padding: '2% 2% 0% 2%' }}>
                        <span className="welcomeText">Welcome to Lé Heaven Inn</span>
                        <span className="wantToLiveText">You'll Never Want To Leave</span>
                    </div>

                    <div style={{ padding: '2% 2% 0% 2%' }}>
                        <div class="row">
                            <div class="col-md-7 order-md-last d-flex">
                                <img data-aos="fade-left" src={home4} alt="" className='home4Img' />
                                {/* <img data-aos="fade-left" src={home1} alt="" style={{ width: '330px', height: '437px' }} />
                                <img data-aos="fade-left" src={home2} alt="" style={{ width: '330px', height: '437px', marginLeft: '15px', marginTop: '15px' }} /> */}
                            </div>
                            <div class="col-md-5">
                                <div class="heading-section mb-4 my-5 my-md-0">
                                    <span class="subheading" data-aos="fade-right">About Lé Heaven Inn</span>
                                    <h2 class="mb-4" data-aos="fade-right">Lé Heaven Inn the Most Recommended Villa All Over the World</h2>
                                </div>
                                <p data-aos="fade-right">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there
                                    live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics,
                                    a large language ocean.</p>
                            </div>
                        </div>
                    </div>

                    {/* <div style={{ padding: '2% 2% 0% 2%' }}>
                        <div class="row d-flex">
                            <div class="col-md-7" style={{ height: '0%' }}>
                                <img data-aos="fade-left" src={home3} alt="" style={{ width: '759px', height: '80%' }} />
                            </div>
                            <div class="col-md-5 wrap-about" style={{ height: '0%' }}>
                                <div class="heading-section">
                                    <span class="subheading" data-aos="fade-right">About Lé Heaven Inn</span>
                                    <h2 class="mb-4" data-aos="fade-right">Lé Heaven Inn the Most Recommended Villa All Over the World</h2>
                                </div>
                                <p data-aos="fade-right">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there
                                    live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics,
                                    a large language ocean.</p>
                            </div>
                        </div>
                    </div> */}
                </Element>
                <Element name="stay">
                    <div style={{ padding: '0% 2% 0% 2%' }}>
                        <div className='stayText' data-aos="fade-right">
                            Stays
                        </div>
                        <div className='stay-card-grid' ref={stayGridRef}>
                            <div className='stay-card-wrapper' data-aos="fade-right">
                                <div className="card shadow stay-card">
                                    <div className="card-body stay-card-body">
                                        <img className='cardImage' src={cortage} alt="Villa Stay" />
                                        <h5 className="card-title mt-4">Villa Stay</h5>
                                        <h6 className="card-subtitle mb-2 text-muted">In Lé Heaven Inn</h6>
                                        <p className="card-text">Lé Heaven Inn offers a luxurious escape with breathtaking views and comfort. With spacious rooms, private pools, and top-notch amenities, it’s the perfect spot for relaxation and peace.</p>
                                        <div className='card-action-row'>
                                            <Link to="gallery" smooth={true} duration={500} className="card-link cardFooterGalleryBtn">
                                                View Gallery
                                            </Link>
                                            <LinkRouter to="/BookNow" className="card-link cardFooterBookBtn">Book Now</LinkRouter>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='stay-card-wrapper' data-aos="fade-up">
                                <div className="card shadow stay-card">
                                    <div className="card-body stay-card-body">
                                        <img className='cardImage' src={mezzanine} alt="Mezzanine Stay" />
                                        <h5 className="card-title mt-4">Mezzanine Stay</h5>
                                        <h6 className="card-subtitle mb-2 text-muted">In Lé Heaven Inn</h6>
                                        <p className="card-text">Mezzanine Stay offers a luxurious escape with stunning views and exceptional comfort. It’s the ideal destination for relaxation and tranquility.</p>
                                        <div className='card-action-row'>
                                            <Link to="gallery" smooth={true} duration={500} className="card-link cardFooterGalleryBtn">
                                                View Gallery
                                            </Link>
                                            <LinkRouter to="/BookNow" className="card-link cardFooterBookBtn">Book Now</LinkRouter>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='stay-card-wrapper' data-aos="fade-left">
                                <div className="card shadow stay-card">
                                    <div className="card-body stay-card-body">
                                        <img className='cardImage' src={room} alt="Room Stay" />
                                        <h5 className="card-title mt-4">Room Stay</h5>
                                        <h6 className="card-subtitle mb-2 text-muted">In Lé Heaven Inn</h6>
                                        <p className="card-text">Rooms provide a lavish retreat with captivating views and comfort. With expansive space and top-tier amenities, these rooms offer the perfect setting for relaxation and serenity.</p>
                                        <div className='card-action-row'>
                                            <Link to="gallery" smooth={true} duration={500} className="card-link cardFooterGalleryBtn">
                                                View Gallery
                                            </Link>
                                            <LinkRouter to="/BookNow" className="card-link cardFooterBookBtn">Book Now</LinkRouter>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Element>
                <Element name='gallery'>
                    <div style={{ padding: '0% 2% 0% 2%' }}>
                        <div className='stayText'>
                            Gallery
                        </div>
                        <div className="gallery-container">
                            <div className="gallery-item">
                                <img src={gallery1} alt='' />
                            </div>
                            <div className="gallery-item">
                                <img src={gallery2} alt='' />
                            </div>
                            <div className="gallery-item">
                                <img src={gallery3} alt='' />
                            </div>
                            <div className="gallery-item">
                                <img src={gallery4} alt='' />
                            </div>
                            <div className="gallery-item">
                                <img src={gallery5} alt='' />
                            </div>
                            <div className="gallery-item">
                                <img src={gallery6} alt='' />
                            </div>
                            <div className="gallery-item">
                                <img src={gallery7} alt='' />
                            </div>
                            <div className="gallery-item">
                                <img src={gallery8} alt='' />
                            </div>
                            <div className="gallery-item">
                                <img src={gallery9} alt='' />
                            </div>
                            <div className="gallery-item">
                                <img src={gallery10} alt='' />
                            </div>
                            <div className="gallery-item">
                                <img src={gallery11} alt='' />
                            </div>
                            <div className="gallery-item">
                                <img src={gallery12} alt='' />
                            </div>
                            <div className="gallery-item">
                                <img src={gallery13} alt='' />
                            </div>
                            <div className="gallery-item">
                                <img src={gallery14} alt='' />
                            </div>
                            <div className="gallery-item">
                                <img src={gallery15} alt='' />
                            </div>
                            {/* {images.map((image, index) => (
                                <div className="gallery-item" key={index}>
                                    <img src={image} alt={`Gallery Image ${index + 1}`} />
                                </div>
                            ))} */}
                        </div>
                    </div>
                </Element>
                <Element name='facilities'>
                    <div style={{ padding: '0% 2% 0% 2%' }}>
                        <div className='stayText' data-aos="fade-right">
                            Facilities
                        </div>
                        <div>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <div data-aos="fade-right">
                                        <img style={{ width: '100%',borderRadius:'15px',boxShadow:"0px 0px 14px" }} src={facilities1} alt='' />
                                    </div>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <div data-aos="fade-left">
                                        <div className='facilityText'>TV Facility</div>
                                        <div className='facilityContentText'>
                                            Lé Heaven Inn offers an exceptional TV facility, designed to enhance your stay with premium entertainment options. The villa features a state-of-the-art entertainment system, with large, high-definition TVs in every major room, including the living area and bedrooms. Guests can enjoy a wide range of channels, including international and local options, as well as streaming services for on-demand viewing. The smart TV system ensures ease of use with user-friendly interfaces, allowing you to quickly access your favorite shows, movies, and apps. Whether you're relaxing in the lounge or unwinding in the privacy of your bedroom, Lé Heaven Inn ensures a perfect balance of comfort and entertainment for an unforgettable stay.
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12 order-md-last'>
                                    <div data-aos="fade-left">
                                        <img style={{ width: '100%',borderRadius:'15px',boxShadow:"0px 0px 14px" }} src={facilities2} alt='' />
                                    </div>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <div data-aos="fade-right" style={{ marginTop: '15%' }}>
                                        <div className='facilityText'>AC Facility</div>
                                        <div className='facilityContentText'>
                                            Lé Heaven Inn offers a premium experience with its fully air-conditioned rooms, ensuring comfort throughout your stay. Each AC room is designed to provide a cool and relaxing environment, ideal for unwinding after a day of activities. The air conditioning systems are modern and efficient, allowing you to set the perfect temperature for a restful night’s sleep. Whether you're in the spacious living room or the cozy bedrooms, you’ll enjoy a consistently comfortable atmosphere. Lé Heaven Inn’s air-conditioned rooms are the perfect retreat for those looking to experience luxury and relaxation in a serene setting.
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <div data-aos="fade-right">
                                        <img style={{ width: '100%',borderRadius:'15px',boxShadow:"0px 0px 14px" }} src={facilities3} alt='' />
                                    </div>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <div data-aos="fade-left" style={{ marginTop: '10%' }}>
                                        <div className='facilityText'>Free WIFI Facility</div>
                                        <div className='facilityContentText'>
                                            Lé Heaven Inn offers complimentary high-speed Wi-Fi throughout the property, ensuring you stay connected during your stay. Whether you're in the spacious living area, your private bedroom, or relaxing by the pool, you’ll have seamless access to fast and reliable internet. Perfect for browsing, streaming, or working remotely, the free Wi-Fi at Lé Heaven Inn allows you to stay in touch with the outside world while enjoying the comforts of your luxurious surroundings. Stay connected, share your memories, and make the most of your stay with this convenient and inclusive amenity.
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12 order-md-last'>
                                    <div data-aos="fade-left">
                                        <img style={{ width: '100%',borderRadius:'15px',boxShadow:"0px 0px 14px" }} src={facilities4} alt='' />
                                    </div>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <div data-aos="fade-right" style={{ marginTop: '15%' }}>
                                        <div className='facilityText'>Swimming Pool Facility</div>
                                        <div className='facilityContentText'>
                                            Lé Heaven Inn features a stunning private swimming pool, offering a refreshing and relaxing oasis right at your doorstep. The pool is designed for ultimate comfort, with crystal-clear water and a spacious deck area perfect for lounging. Whether you're taking a leisurely swim, enjoying a poolside drink, or soaking up the sun, the pool provides the perfect setting for relaxation and recreation. Surrounded by lush greenery and serene surroundings, the swimming pool at Lé Heaven Inn is an ideal place to unwind and enjoy your vacation in style.
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <div data-aos="fade-right">
                                        <img style={{ width: '100%', height: '550px',borderRadius:'15px',boxShadow:"0px 0px 14px" }} src={facilities5} alt='' />
                                    </div>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <div data-aos="fade-left" style={{ marginTop: '10%' }}>
                                        <div className='facilityText'>Pergola Facility</div>
                                        <div className='facilityContentText'>
                                            The pergola at Lé Heaven Inn offers a serene outdoor retreat, featuring elegant beams draped with lush greenery. Perfect for relaxation or intimate gatherings, it blends beautifully with the villa's surroundings, providing a peaceful space to enjoy the fresh air and scenic views.
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </Element>
                <div className='pt-1'>
                    <Footer />
                </div>
            </div>

        </div>
    )
}

export default Home;